import styled from 'styled-components';
import { FilterBar } from 'components/molecules/filter-bar';
import { ProductiveHeading07 } from 'components/styles';

export const SettingsLabelWithoutMargin = styled.p`
  ${ProductiveHeading07};
  margin-bottom: 0;
`;

export const SettingsLabel = styled.p`
  ${ProductiveHeading07};
  margin-bottom: var(--spacing-03);
  display: flex;
  align-items: center;
`;

export const SettingsFilterBar = styled(FilterBar)`
  box-shadow: none !important;
`;

export const SettingsPageContainer = styled.div`
  > div {
    max-width: 852px;
    overflow: hidden !important;
  }
  padding: var(--layout-02);
  overflow-y: auto;
  overflow-x: hidden;
`;
